(() => {
  const getFsElement = () =>
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement;

  const requestFs = (el) => {
    if (!el) return;
    const fn = el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen;
    if (fn) fn.call(el);
  };

  const exitFs = () => {
    const fn = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
    if (fn) fn.call(document);
  };

  const initMobileSwipers = () => {
    if (!window.matchMedia('(max-width: 1023px)').matches) return;
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.mobile-swiper').forEach((swiperEl) => {
      const paginationEl = swiperEl.querySelector('.swiper-pagination');
      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 12,
        loop: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        autoplay: {
          delay: 4200,
          disableOnInteraction: false,
        },
      });

      // Double-tap to toggle fullscreen on mobile
      let lastTap = 0;
      swiperEl.addEventListener(
        'touchend',
        (event) => {
          const now = Date.now();
          if (now - lastTap < 350) {
            event.preventDefault?.();
            if (getFsElement()) {
              exitFs();
              lastTap = now;
              return;
            }
            requestFs(swiperEl);
          }
          lastTap = now;
        },
        { passive: false }
      );
    });
  };

  const initDesktopFullscreen = () => {
    if (!window.matchMedia('(min-width: 768px)').matches) return;
    document.querySelectorAll('.slideshow').forEach((slideEl) => {
      const btn = slideEl.querySelector('.fullscreen-btn');
      if (!btn) return;
      btn.addEventListener('click', (event) => {
        event.stopPropagation();
        const isFullscreen = !!getFsElement();
        if (!isFullscreen) {
          requestFs(slideEl);
        } else {
          exitFs();
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initMobileSwipers();
    initDesktopFullscreen();
  });
})();
